/**
 * FarmPacks — accessible names for frames we do not author.
 *
 * Apps drop <iframe> elements into the page long after it has loaded, and
 * several arrive with no title. A screen reader then announces only "frame",
 * which tells someone nothing about whether it is worth entering.
 *
 * We cannot change what those apps emit, but the element is in our document,
 * so we can name it. Only ever fills a gap: an iframe that already has a
 * title, an aria-label or an aria-labelledby is left exactly as it is.
 */
(function () {
  if (window.__fpA11yBound) return;
  window.__fpA11yBound = true;

  // Frames we recognise get a name that says what they are. Anything else
  // falls back to its origin, which is honest about what it can promise.
  var KNOWN = [
    { match: /\/shopping\/merchantverse/, title: 'Google Shopping merchant widget' },
    { match: /judge\.me/, title: 'Judge.me reviews' },
  ];

  function named(frame) {
    return Boolean(
      (frame.getAttribute('title') || '').trim() ||
        (frame.getAttribute('aria-label') || '').trim() ||
        frame.getAttribute('aria-labelledby')
    );
  }

  function describe(frame) {
    var src = frame.getAttribute('src') || frame.getAttribute('data-src') || '';

    for (var i = 0; i < KNOWN.length; i++) {
      if (KNOWN[i].match.test(src)) return KNOWN[i].title;
    }

    try {
      return 'Embedded content from ' + new URL(src, window.location.href).hostname;
    } catch (error) {
      return 'Embedded content';
    }
  }

  function label(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var frames = [].slice.call(scope.querySelectorAll('iframe, frame'));
    if (scope !== document && scope.tagName === 'IFRAME') frames.push(scope);

    for (var i = 0; i < frames.length; i++) {
      if (named(frames[i])) continue;
      frames[i].setAttribute('title', describe(frames[i]));
    }
  }

  label(document);

  // The widgets that miss a title are exactly the ones that arrive late.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) label(added[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
